/** Same shape as @kivunova/kivufrontendcommon store query; kept local (not exported from package root). */
export const listCompanyStoresQuery = `
  query ListStores($input: ListStoresInput!) {
    listStores(input: $input) {
      code
      stores {
        id
        companyId
        name
      }
    }
  }
`;
